import { LandRegistryOwnership } from '@core/api';
import { apiActionFactory } from '@core/store';

export const [fetchLandRegistryOwnershipSuccess, fetchLandRegistryOwnershipFail] = apiActionFactory<{
  ownership: LandRegistryOwnership;
  titleNumber: string;
}>('[Data Layers/API] Fetch LandRegistry Ownership');
